var _path, _path2, _line, _line2, _line3, _path3, _circle, _line4, _line5, _line6, _line7, _line8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116.4 141.3",
    enableBackground: "new 0 0 116.4 141.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fallen Magnifier_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-60",
    fill: "#005D9A",
    d: "M51.1,42.1C46.6,46,46,52.9,49.9,57.5c3.9,4.6,10.8,5.1,15.4,1.2s5.1-10.8,1.2-15.4 c-3.9-4.5-10.6-5.1-15.2-1.3L51.1,42.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-64",
    fill: "#EAF1F4",
    d: "M65.9,44.6c-3.2-3.8-8.9-4.3-12.7-1.1c-3.8,3.2-4.3,8.9-1.1,12.7c3.2,3.8,8.9,4.3,12.7,1.1 C68.6,54.1,69.1,48.4,65.9,44.6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 67.9,
    y1: 69.3,
    x2: 67.9,
    y2: 98.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 59.2,
    y1: 62.1,
    x2: 59.2,
    y2: 86.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 49.8,
    y1: 70.1,
    x2: 49.8,
    y2: 111.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M42.1,113.7V50.1 c0-9.3,7.6-16.9,16.9-16.9h0c9.4,0,17,7.6,17,17v29.1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    cx: 59.1,
    cy: 50.4,
    r: 10.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 67.9,
    y1: 90,
    x2: 67.9,
    y2: 98
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "90; 115;",
    begin: "0s",
    dur: "0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "98; 115;",
    begin: "0s",
    dur: "0.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 0;",
    begin: "0s",
    dur: "0.5s",
    repeatCount: "indefinite"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 59.2,
    y1: 70,
    x2: 59.2,
    y2: 87
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "70; 110;",
    begin: "0s",
    dur: "0.4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "87; 110;",
    begin: "0s",
    dur: "0.4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 0;",
    begin: "0s",
    dur: "0.4s",
    repeatCount: "indefinite"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 49.8,
    y1: 90,
    x2: 49.8,
    y2: 112
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "90; 128;",
    begin: "0.2s",
    dur: "0.3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "112; 128;",
    begin: "0.2s",
    dur: "0.3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 1; 0;",
    begin: "0.2s",
    dur: "0.3s",
    repeatCount: "indefinite"
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 42.1,
    y1: 100,
    x2: 42.1,
    y2: 114
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "100; 132;",
    begin: "0s",
    dur: "0.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "114; 132;",
    begin: "0s",
    dur: "0.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 0;",
    begin: "0s",
    dur: "0.2s",
    repeatCount: "indefinite"
  }))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#005D9A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 76,
    y1: 60,
    x2: 76,
    y2: 78
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "y1",
    values: "60; 80;120;",
    begin: "0s",
    dur: "0.35s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y2",
    values: "78; 98; 120;",
    begin: "0s",
    dur: "0.35s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1; 1; 0;",
    begin: "0s",
    dur: "0.35s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.17b5001e.svg";
export { ForwardRef as ReactComponent };